import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../context/auth";

export default function PermissionMonitorDelivery() {
    const {ActivEmp} = useContext(auth);

    if(ActivEmp.role !== "delivery") {
        return <Navigate to={'pos'} replace />            
    }
    return <Outlet />
}